import { ProjectsConfiguratorV2Component } from '@modules/projects/modules/projects-configurator-v2/projects-configurator-v2.component';
import { CustomRoutes } from '@shared/consts/routes/custom-routes.const';

export const ProjectConfiguratorV2Routes: CustomRoutes = [
  {
    path: '',
    component: ProjectsConfiguratorV2Component
  }
];
